<script>
  import { onMount } from "svelte"
  import Dropdown from "../Table/Components/numberDropdown.svelte"
  import Pagination from "../Table/Components/pagination.svelte"
  import { createEventDispatcher } from "svelte"
  const dispatch = createEventDispatcher()
  export let list
  export let filterComponent = ""
  export let nameSort = true
  export let title = ""
  export let jsonData
  export let filter = false
  export let search = true
  export let dateSort = true
  export let sortNameParam = "name"
  export let searchParam = "id"
  export let expiryTable = false
  export let showDownloadSpreadSheet = false
  let searched = false
  /**
   * @type {Boolean} - controls the show or hide the FilterForm.
   */
  let showFilterForm = false

  /**
   * @type {Number} - how many list need to show
   */
  let entries = 10

  /**
   * @type {Array<Number>} - entry list in dropdown list
   */
  let entriesList = [10, 50, 100]

  /**
   * @type {Number} - active page number
   */
  let activePage = 1

  /**
   * @type {Array<jsonData>} - it consists of filtered json list. It displayed in list.
   */
  let sortData = []

  /**
   * @type {Number} - how many pages for the overall list
   */
  let maxPage

  /**
   * @type {Boolean} - sort lists ascending or descending using date
   */
  let sortByDateFile = true

  /**
   * @type {Boolean} - sort lists ascending or descending using name
   */
  let sortByNameFile = true

  /**
   * @type {String} - find list in search method using this string
   */
  let searchId

  /**
   * @description function for what are list need to show
   * @function listEntries
   * @param entries how many list need to show
   */

  /**
   * initial list created
   */
  onMount(async () => {
    listEntries(entries)
    toggleSortByDate()
  })

  // $: if (jsonData) listEntries(entries)

  const listEntries = (entries) => {
    // Calculate the maximum number of pages based on the length of jsonData and the number of entries per page
    maxPage = Math.ceil(jsonData.length / entries)

    // Create an empty array to store the sorted data
    sortData = []

    // Iterate through jsonData starting from the index corresponding to the current page
    // if (!sortData.length) {
    for (let i = entries * (activePage - 1); i < jsonData.length; i++) {
      // Check if the sortData array has reached the desired number of entries per page
      if (sortData.length < entries) {
        // Add the current jsonData element to the sortData array
        sortData = [...sortData, jsonData[i]]
      }

      // }
    }
  }

  /**
   * @description function for sort list ascending or descending based on name
   * @function toggleSortByName
   */
  const toggleSortByName = () => {
    searched = false
    // Check if the sortByNameFile flag is true
    if (sortByNameFile) {
      // If true, sort the sortData array in ascending order based on the "Name" property
      sortData = jsonData.sort((a, b) => a[sortNameParam].localeCompare(b[sortNameParam]))
    } else {
      // If false, sort the sortData array in descending order based on the "Name" property
      sortData = jsonData.sort((a, b) => b[sortNameParam].localeCompare(a[sortNameParam]))
    }
    listEntries(entries)
    // Invert the value of the sortByNameFile flag
    sortByNameFile = !sortByNameFile
  }

  /**
   * @description function for sort list ascending or descending based on date
   * @function toggleSortByDate
   */
  const toggleSortByDate = () => {
    searched = false
    // Check if the sortByDateFile flag is true
    if (!sortByDateFile) {
      // If true, sort the sortData array in ascending order based on the "Date" property
      sortData = jsonData.sort((a, b) => new Date(a.created) - new Date(b.created))
    } else {
      // If false, sort the sortData array in descending order based on the "Date" property
      sortData = jsonData.sort((a, b) => new Date(b.created) - new Date(a.created))
    }
    listEntries(entries)

    // Invert the value of the sortByDateFile flag
    sortByDateFile = !sortByDateFile
  }

  /**
   * @description function for search list using id
   * @function searchList
   */
  const searchList = () => {
    sortData = [] // Clear the sortData array before performing the search
    sortData = jsonData.filter((item) => item[searchParam].toLowerCase().match(searchId.toLowerCase()))
    searched = true
  }
</script>

<div class="mx-auto w-full space-y-3">
  <div class="flex justify-between">
    {#if title}
      <div class="w-full select-none text-xl font-bold text-black dark:text-white lg:text-2xl xl:text-2xl">{title}</div>
    {/if}
  </div>

  <!-- Table header -->
  <div class="flex w-full flex-col items-center justify-between gap-3 sm:flex-row">
    <!-- Select entries dropdown & Sort -->
    <div class="flex w-full items-center justify-between gap-3">
      <div class="flex w-full items-center gap-1.5 mobile:gap-3">
        <span class="hidden min-w-fit select-none text-sm font-medium text-gray-200 mobile:block md:text-base">Displayed entries</span>
        <span class="block min-w-fit select-none text-sm font-medium text-gray-200 mobile:hidden md:text-base">Entries</span>
        <!-- dropdown -->
        {#if !searched}
          <div>
            <Dropdown
              dropdownItems={entriesList}
              on:itemSelect={(e) => {
                entries = e.detail
                activePage = 1
                listEntries(entries)
              }}
            />
          </div>
        {:else}
          <span class="select-none font-mono font-bold text-blue-500">{sortData.length}</span>
        {/if}
      </div>

      <!-- Sort list buttons -->
      <div class="flex gap-1.5 mobile:gap-3">
        <!-- Name sort -->
        {#if nameSort}
          <button disabled={!nameSort} data-tooltip="Sort by Name in {!sortByNameFile ? 'Descending' : 'Ascending'} order" tooltip-position="left" type="button" on:click={toggleSortByName} class="flex h-9 min-h-full w-9 min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-white px-2 text-sm font-medium text-gray-800 hover:bg-yellow-500 hover:text-white focus:outline-none active:bg-yellow-600 active:text-white disabled:cursor-not-allowed dark:bg-lightgray dark:text-white dark:hover:bg-yellow-500">
            <i class="fa-solid {!sortByNameFile ? 'fa-arrow-up-z-a' : 'fa-arrow-up-a-z'} " />
          </button>
        {/if}

        {#if dateSort}
          <!-- Date sort -->
          <button disabled={!sortData.length} data-tooltip="Sort by Date,{sortByDateFile ? 'Newest' : 'Oldest'} First" tooltip-position="left" type="button" on:click={toggleSortByDate} class="flex h-9 min-h-full w-9 min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-white px-2 text-sm font-medium text-gray-800 hover:bg-yellow-500 hover:text-white focus:outline-none active:bg-yellow-600 active:text-white disabled:cursor-not-allowed dark:bg-lightgray dark:text-white dark:hover:bg-yellow-500">
            <i class="fa-solid {sortByDateFile ? 'fa-calendar-arrow-up' : ' fa-calendar-arrow-down'}" />
          </button>
        {/if}
        <!-- filter section -->
        {#if filter}
          <div class="relative flex w-full select-none justify-end">
            <button disabled={!sortData.length} on:click={() => (showFilterForm = !showFilterForm)} class="flex h-9 min-h-full w-9 min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-white px-2 text-sm font-medium text-gray-800 hover:bg-green-500 hover:text-white focus:outline-none active:bg-green-600 active:text-white disabled:cursor-not-allowed dark:bg-lightgray dark:text-white dark:hover:bg-green-500">
              <i class="fa-solid fa-filter" />
            </button>
            {#if showFilterForm}
              <svelte:component this={filterComponent} bind:searched bind:showFilterForm bind:sortData bind:jsonData />
            {/if}
          </div>
        {/if}
      </div>
    </div>

    <!-- Search -->
    {#if search}
      <form on:submit|preventDefault|stopPropagation={searchList} class="relative flex w-full justify-between gap-3 sm:justify-end md:w-auto">
        <input placeholder="Search {searchParam == 'id' ? 'ID' : 'Name'}" type="text" bind:value={searchId} class="w-full rounded-md border border-[#a0a1a580] bg-white py-2 pl-3 pr-9 text-sm text-gray-800 outline-none placeholder:font-normal placeholder:text-gray-500 invalid:animate-shake invalid:border-red-500 invalid:placeholder-red-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 dark:bg-transparent dark:text-white sm:text-sm md:w-[240px]" />
        <button disabled={!searchId} type="submit" class="absolute right-0 z-10 flex h-9 w-9 cursor-pointer items-center justify-center text-base font-semibold text-gray-800 hover:text-blue-400 focus:outline-none active:text-blue-600 disabled:cursor-not-allowed disabled:text-gray-300">
          <i class="fa-solid fa-magnifying-glass" />
        </button>
      </form>
    {/if}
  </div>

  <!-- List component -->
  {#if sortData.length}
    {#each sortData as Json, i}
      <svelte:component
        this={list}
        json={Json}
        on:dateChanged={(e) => {
          jsonData.map((json) => {
            if (e.detail.string == json.string) json = e.detail
            showDownloadSpreadSheet = true
            return jsonData
          })
          // console.log(jsonData)
        }}
        on:delete={(e) => {
          jsonData = jsonData.filter((json) => json.id != e.detail)
          listEntries(entries)
        }}
      />
    {/each}
    {#if expiryTable}
      <div class="flex justify-end gap-3">
        <button
          on:click={() => {
            dispatch("closeTable")
          }}
          class="h-[36px] w-fit rounded-md bg-red-500 px-5 py-1 text-sm font-normal tracking-wider text-white hover:border-transparent hover:bg-red-600"
        >
          <i class="fa-solid fa-circle-xmark" />
          <span>Close</span>
        </button>
        <button
          on:click={() => {
            dispatch("confirmDate")
          }}
          class="h-[36px] w-fit rounded-md bg-green-500 px-5 py-1 text-sm font-normal tracking-wider text-white hover:border-transparent hover:bg-green-600"
        >
          <i class="fa-solid fa-circle-check" />
          <span>Confirm&nbsp;All</span>
        </button>
      </div>
    {/if}
  {:else}
    <div class="text-secondary2 select-none rounded-md bg-white py-6 text-center text-lg dark:bg-bodyblack dark:text-white mobile:text-2xl">There is no data</div>
  {/if}

  <!-- Table footer  -->
  {#if !searched && sortData.length}
    <div class="flex w-full select-none flex-col items-center justify-between gap-3 text-sm sm:flex-row sm:gap-0 sm:text-base">
      <!-- How many entries shows in total entries -->
      <p class="font-medium text-gray-200">
        Showing {activePage * entries - entries + 1} to {activePage * entries > jsonData.length ? jsonData.length : activePage * entries} of
        <span class="font-mono font-bold text-blue-500">{jsonData.length}</span>
        entries
      </p>
      <!-- Pagination -->
      <Pagination
        {maxPage}
        {activePage}
        on:pageNo={(e) => {
          activePage = e.detail
          listEntries(entries)
        }}
      />
    </div>
  {:else}
    <div class="flex select-none items-center justify-between pb-6">
      <p class="font-medium text-gray-200">
        There are
        <span class="font-mono font-bold text-blue-500">{sortData.length}</span>
        entries found
      </p>
      <button
        on:click={() => {
          sortData = []
          listEntries(10)
          searchId = ""
          searched = false
        }}
        class="float-right flex h-9 w-32 min-w-[36px] cursor-pointer items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 focus:outline-none active:bg-blue-500 disabled:cursor-not-allowed disabled:bg-blue-300 lg:px-4"
      >
        <i class="fa-solid fa-rotate-left" />
        &nbsp;&nbsp;Reset
      </button>
    </div>
  {/if}
</div>
